Wee.fn.make('seasonalPromo', {
	init: function() {
		var $form = $('ref:seasonalPromoForm'),
			priv = this.$private;

		Wee.infieldLabels.init();

		// Bind form submission
		$form.on('submit', function(e, el) {
			var $el = $(el);

			// Submit form via ajax
			$.fetch.request({
				method: 'post',
				data: $el.serialize(),
				success: function(response) {
					var success = response.success,
						errors = response.errors;

					// Reset error messages
					$('ref:errorMessage').text('');

					var a = document.createElement('a');
					a.href = $.get('seasonalDownloadLink');
					a.download = $.get('seasonalDownloadName');
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);


					// Notify user of submission state
					if (! success && errors && Object.keys(errors).length) {
						for (var error in errors) {
							priv.insertErrors(error, errors[error]);
						}
					} else {
						$el.prepend($.view.render('seasonal-success', {
							text: $.get('seasonalText')
						}));
						$el.find('ref:close').hide();
						$('ref:close').hide();
					}
				}
			});

			e.preventDefault();
		});
	}
}, {
	insertErrors: function(type, errors) {
		$('ref:' + type + 'Error').text(errors[0]);
	}
});
